import './constants.credit-card';
import './services.sl-payment';
import loggerService from '../../utils/loggerService';
import withRetry from '../../utils/withRetry';

// SLPayment: data.code 1109 indicates an unstable network; transient error, safe to retry
const RETRYABLE_SDK_ERROR_CODES = new Set(['1109']);
const MAX_SDK_INIT_RETRIES = 3;

app.directive('checkoutShoplinePaymentV2', [
  'slPaymentService',
  'cart',
  '$rootScope',
  'slFeatureService',
  'creditCard',
  function (slPaymentService, cart, $rootScope, slFeatureService, creditCard) {
    return {
      restrict: 'A',
      scope: {
        onSdkInit: '&',
        useShoplinePaymentQuickPayment: '=?',
      },
      link: function (scope) {
        try {
          const isSubscriptionOrder = cart.items?.some(
            (item) => item.type === 'subscription_product',
          );

          const paymentConfig = {
            ...slPaymentService.getDefaultPaymentConfig(cart.payment_method),
            amount:
              cart.total.currency_iso === 'TWD'
                ? cart.total.cents * 100
                : cart.total.cents,
            customerToken: '',
            paymentInstrument: {
              bindCard: {
                enable: false,
                protocol: {
                  mustAccept: false,
                  textType: {
                    paymentAgreement: false,
                  },
                  defaultSwitchStatus: false,
                  switchVisible: false,
                },
              },
            },
          };

          const renderSDK = (paymentConfig) => {
            let retryCount = 0;
            let paymentInstance;
            withRetry(
              () => {
                paymentInstance = slPaymentService.createPayment({
                  paymentConfig,
                  elementId: '#checkout-shopline-payment-v2-form',
                });
                return paymentInstance.init();
              },
              {
                maxRetries: MAX_SDK_INIT_RETRIES,
                shouldRetry: (error) =>
                  RETRYABLE_SDK_ERROR_CODES.has(error?.data?.code),
                onRetry: (count) => {
                  retryCount = count;
                  // The SDK renders a fallback notice into the container on each
                  // failed init; destroy the failed instance before retrying so
                  // the notices do not stack up
                  paymentInstance?.destroy();
                },
              },
            )
              .then((data) => {
                scope.onSdkInit({ value: data });
              })
              .catch((error) => {
                loggerService.error(error, {
                  context: { description: 'renderSDKError', retryCount },
                });
              });
          };

          if (
            !slFeatureService.hasFeature('slp_remember_credit_card') ||
            cart.payment_method.config_data.shopline_payment_payment !==
              'credit' ||
            cart.payment_method.config_data?.installments.length > 0
          ) {
            renderSDK(paymentConfig);
            return;
          }

          const initBeforeRenderSDK = async () => {
            if ($rootScope.currentUser) {
              const paymentInstrumentsRes =
                await slPaymentService.getPaymentInstruments();
              const tokenRes = await slPaymentService.getCustomerToken();
              const cardList = paymentInstrumentsRes.data;
              if (tokenRes?.data?.customer_token) {
                paymentConfig.customerToken = tokenRes.data.customer_token;
                paymentConfig.paymentInstrument.bindCard.enable = true;
                scope.useShoplinePaymentQuickPayment = false;
              }

              if (cardList.length < creditCard.CARD_LIST_LIMIT) {
                paymentConfig.paymentInstrument.bindCard.protocol.textType.paymentAgreement = true;
                paymentConfig.paymentInstrument.bindCard.protocol.switchVisible = true;
                scope.useShoplinePaymentQuickPayment = true;
              }

              if (cardList.length === creditCard.CARD_LIST_LIMIT) {
                scope.useShoplinePaymentQuickPayment = true;
              }

              if (isSubscriptionOrder) {
                paymentConfig.paymentInstrument = {
                  bindCard: {
                    enable: true,
                    protocol: {
                      mustAccept: true,
                      textType: {
                        paymentAgreement: true,
                        subscribeAgreement: true,
                      },
                      defaultSwitchStatus: false,
                      switchVisible: true,
                    },
                  },
                };
              }

              renderSDK(paymentConfig);
            } else {
              if (isSubscriptionOrder) {
                paymentConfig.paymentInstrument = {
                  bindCard: {
                    enable: true,
                    protocol: {
                      mustAccept: true,
                      textType: {
                        paymentAgreement: false,
                        subscribeAgreement: true,
                      },
                      defaultSwitchStatus: true,
                      switchVisible: false,
                    },
                  },
                };
              }

              renderSDK(paymentConfig);
            }
          };

          initBeforeRenderSDK();
        } catch (e) {
          loggerService.error(e);
        }
      },
    };
  },
]);
